export const stats = [5, 4, 3, 2, 1]

export const defaultRating = {
  avgRating: 0.0,
  stats: [],
}

export const serviceOptions = [
  { id: 0, value: 'google', label: 'Google', iconPng: '/images/socials/google-icon.png' },
  {
    id: 1,
    value: 'apartments',
    label: 'Apartments.com',
    iconPng: '/images/socials/apartments-icon.png',
  },
]

export const platformInfo = {
  google: {
    label: 'Google',
    iconPng: '/images/socials/google-icon.png',
    allowMultipleReplies: false,
    allowEditingReplies: true,
  },
  apartments: {
    label: 'Apartments.com',
    iconPng: '/images/socials/apartments-icon.png',
    allowMultipleReplies: true,
    allowEditingReplies: false,
  },
}

export const defaultOverviewAnalytics = {
  reviewCount: 0,
  highRated: 0,
  lowRated: 0,
  avgReplyTime: 0,
  reviewCountDiff: 0,
  highRatedDiff: 0,
  lowRatedDiff: 0,
  avgReplyTimeDiff: 0,
}

export const getDefaultRatingOptions = (t) => [
  { label: t('organisation:reputationManagement.all'), checked: true, isAll: true },
  { label: '5', checked: true },
  { label: '4', checked: true },
  { label: '3', checked: true },
  { label: '2', checked: true },
  { label: '1', checked: true },
]

export const ratings = [
  { stars: 5, count: 322, percentage: 47 },
  { stars: 4, count: 322, percentage: 40 },
  { stars: 3, count: 322, percentage: 10 },
  { stars: 2, count: 322, percentage: 2 },
  { stars: 1, count: 322, percentage: 1 },
  { stars: 0, count: 119 },
]

export const getPeriodOptions = (t) => [
  { id: 0, text: t('organisation:reputationManagement.periodOptions.month'), value: 'month' },
  { id: 1, text: t('organisation:reputationManagement.periodOptions.quarter'), value: 'quarter' },
  { id: 2, text: t('organisation:reputationManagement.periodOptions.year'), value: 'year' },
]

export const getDefaultPlatforms = (t) => [
  { label: t('organisation:reputationManagement.all'), checked: true, isAll: true },
  ...serviceOptions.map(({ label, value }) => ({ label, value, checked: true })),
]

export const handleCheckboxChange = (index, setFn) => {
  setFn((prev) => {
    const newArr = [...prev]

    if (index === 0) {
      const newCheckedState = !newArr[0].checked
      return newArr.map((item) => ({ ...item, checked: newCheckedState }))
    } else {
      newArr[index].checked = !newArr[index].checked

      if (!newArr[index].checked) {
        newArr[0].checked = false
      } else {
        const allChecked = newArr.slice(1).every((item) => item.checked)
        newArr[0].checked = allChecked
      }

      return newArr
    }
  })
}

export const getRatingOptions = (t) => [
  { id: 0, text: t('organisation:reputationManagement.all'), value: 0 },
  { id: 1, text: '1', value: 1 },
  { id: 2, text: '2', value: 2 },
  { id: 3, text: '3', value: 3 },
  { id: 4, text: '4', value: 4 },
  { id: 5, text: '5', value: 5 },
]

export const getPlatformOptions = (t) => [
  { id: serviceOptions.length, text: t('organisation:reputationManagement.all'), value: 'all' },
  ...serviceOptions.map((option) => ({ ...option, text: option.label })),
]

// Note: unused (dead export) — left untranslated.
export const locationOptions = [
  { id: 0, text: 'Location 1', value: '1' },
  { id: 1, text: 'Location 2', value: '2' },
  { id: 2, text: 'Location 3', value: '3' },
]

export const MODAL_MODE = {
  CONNECTIONS: 'connections',
  LOCATIONS: 'locations',
  APARTMENTS: 'apartments',
}

export const getPeriodTime = (period) => {
  let from = new Date().getTime()
  let to = new Date().getTime()
  switch (period.value) {
    case 'month':
      from = new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime()
      break
    case 'quarter':
      from = new Date(new Date().setMonth(new Date().getMonth() - 3)).getTime()
      break
    case 'year':
      from = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime()
      break
    default:
      break
  }

  return { from, to }
}
